import script from "./PerformerProjectFormStep4.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep4.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep4.vue?vue&type=style&index=0&id=1e70d8d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e70d8d2"]])

export default __exports__